export const ErrorCode = {
  Login: {
    NotFound: 'UserNotFoundException',
    NotConfirmed: 'UserNotConfirmedException',
    PasswordResetRequired: 'PasswordResetRequiredException'
  },
  SignUp: {
    UsernameExists: 'UsernameExistsException',
    UnconfirmedAccountExists: 'UnconfirmedAccountExists'
  }
};
